import React, { useState, useEffect } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import { connect } from 'react-redux'
import { errorToBeCleared } from '../../reducers/error'
import { selectAllErrorsMapped } from '../../reducers/index'

function ErrorSnackbar(props) {
  const { children, errors, clearError } = props
  const [open, setOpen] = useState(false)

  useEffect(() => {
    errors.length === 0 ? setOpen(false) : setOpen(true);
  }, [errors]);

  return (
    <div>
      { children }
      {
        errors.map((error, index) => (
            <Snackbar
              key={`snackbar_${error.id}_${index}`}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              open={open}
              
              autoHideDuration={6000}
              message={error.userMessage}
              onClose={() => { clearError(error.id); }}
              
            />
          )
        )
      }
    </div>
  )
}

const mapStateToProps = state => ({
  errors: selectAllErrorsMapped(state),
})

const mapDispatchToProps = dispatch => ({
  clearError: id => dispatch(errorToBeCleared(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorSnackbar);
